export enum ENUM__connection_state {
  CONNECTING = 'CONNECTING',
  CONNECTION_ESTABLISHED = 'CONNECTION_ESTABLISHED',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  DISCONNECTED = 'DISCONNECTED',
}
